import Link from 'next/link';

import IconArrow from '@/assets/icons/iconArrow.svg';

const AllCasesCard = ({
  link,
  text,
  bgUrl,
}: {
  link: string;
  text: string;
  bgUrl: string;
}) => (
  <div className="relative flex h-full items-center justify-center rounded-20 bg-surfaceBaseSecondary hover:cursor-pointer max-sm:hover:cursor-default">
    <img
      src={bgUrl}
      alt="cases-slider-overlay"
      className="pointer-events-none absolute left-0 top-0 h-full w-full rounded-20 object-cover"
    />

    <Link
      href={link}
      className="relative flex h-[56px] w-fit cursor-pointer items-center justify-center rounded-xl bg-customBaseInversePrimary px-6 text-customBasePrimary transition-colors duration-300 hover:bg-customBaseInverseSecondary"
    >
      {text}
      <IconArrow className="ml-2 h-[24px] w-[24px] rotate-[-45deg]" />
    </Link>
  </div>
);
export default AllCasesCard;
